module.exports = "<sheet color=\"red\"><location-picker (locationChanged)=\"onLocationChanged($event)\" [showLocations]=\"showLocations\"></location-picker><div class=\"layout-row layout-align-end layout-padding\"><bw-button title=\"Apply\" icon=\"check\" color=\"white\" [simple]=\"true\" (clicked)=\"onApplyClicked($event)\"></bw-button></div></sheet>";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/location-picker-sheet/location-picker-sheet.component.pug
// module id = 614
// module chunks = 0